/**
 * Created by cedricgodefroy on 18/07/2017.
 */
/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').
    factory('DataSourceFactory',['ReportDatasSource','ReportTemporalAgregateFunctionType','Day','RootStatCategorie','TypeOfSale','HrRootOccupationRateCategory','PrRootOccupationRateCategory',
        'CategoryData','NbCustormerCategoryStat','HrRootCategory','TypeOfBooking','GiftItemRootCategory','LoyaltyCustomers','LoyaltyPeriodDataSource','GiftItemByHrRootCategory','ReportTotalAgregateFunctionType',
        'WorkingTimeRootCategory','TypeOfCustomerRootCategory', 'ProductStatCategorie',
        function (ReportDatasSource,ReportTemporalAgregateFunctionType,Day,RootStatCategorie,TypeOfSale,HrRootOccupationRateCategory,PrRootOccupationRateCategory,CategoryData,
                  NbCustormerCategoryStat,HrRootCategory,TypeOfBooking,GiftItemRootCategory,LoyaltyCustomers,LoyaltyPeriodDataSource,GiftItemByHrRootCategory,ReportTotalAgregateFunctionType,
                  WorkingTimeRootCategory,TypeOfCustomerRootCategory, ProductStatCategorie) {
            var DataSourceFactory = (function () {
                var instance;

                var constructeur = function() {
                    this.createDataSource = function (idReportModel, currentCategorieLabel, currentCategoryType, taxMode, typeOfData) {
                        var dataSource = null;

                        switch (idReportModel) {
                            case "ca":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "ca-by-personnal":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getAverageSalesCaByWorkerOfSaleObject,
                                    null,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "daily-average-ca-by-personnal":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getAverageSalesCaByWorkerOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_AVERAGE,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "nb-sales":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbSubSalesOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "nb-sales-by-personnal":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getAverageNbSubSalesByWorkerOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "daily-average-nb-sales-by-personnal":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getAverageNbSubSalesByWorkerOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_AVERAGE,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "daily-average-nb-visits-by-personnal":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getAverageNbSalesByWorkerOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_AVERAGE,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSalesOfSaleObject,
                                    NbCustormerCategoryStat,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "old-customer":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbSubSalesOldCustomerOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOldCustomerOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "new-customer":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbSubSalesNewCustomerOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesNewCustomerOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "ticket-prd":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbSalesOfSaleObject,
                                    Day.prototype.getNbSalesWithServiceOrProduct,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSalesOfSaleObject,
                                    TypeOfSale.ALL_WITH_PRODUCT_OR_NOT,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "hr-occupation-rate":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getBookingTimeOfHrObject,
                                    Day.prototype.getWorkingTimeOfHrObject,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES,
                                    Day.prototype.getSubBookingsStepOfBookingObject,
                                    HrRootOccupationRateCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "pr-occupation-rate":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getBookingTimeOfPrObject,
                                    Day.prototype.getWorkingTimeOfPrObject,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES,
                                    Day.prototype.getSubBookingsStepOfBookingObject,
                                    PrRootOccupationRateCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "sale-by-hr":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesStepOfSaleObject,
                                    HrRootCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "gift-by-hr":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    GiftItemByHrRootCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "gain-by-minute":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    Day.prototype.getDurationOfSaleObject,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.AVERAGE_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    CategoryData.categoryRoot,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "nb-customers":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbVisitsOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getVisitsOfSaleObject,
                                    NbCustormerCategoryStat,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "average-cart":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    Day.prototype.getNbSoldSalesWithoutGift,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "average-cart-by-gender":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    Day.prototype.getNbSoldSalesOfSaleObject,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSalesOfSaleObject,
                                    NbCustormerCategoryStat,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "average-cart-gift":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    Day.prototype.getNbSalesWithGift,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    GiftItemRootCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "custormer-come":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbBookingsOfBookingObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getBookingsOfBookingObject,
                                    TypeOfBooking.COME_AND_NOT_COME,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "not-honored-booking":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getBookingsCAOfBookingObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getBookingsOfBookingObject,
                                    TypeOfBooking.NOT_COME,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "booking-in-line":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbBookingsOfBookingObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getBookingsOfBookingObject,
                                    TypeOfBooking.CREATE_BY_CUSTORMER_AND_NOT,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "giftItem":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    GiftItemRootCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "fidelity-collaborator-rate":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    null,
                                    {},
                                    null,
                                    null,
                                    null,
                                    LoyaltyCustomers,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData,
                                    LoyaltyPeriodDataSource);
                               break;
                            case "working-time":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getOccupationDatasOfHrObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getHrOccupationPrimaryDatas,
                                    WorkingTimeRootCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData,
                                    null,
                                    true);
                                break;
                            case "old-and-new-customer":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbFirstCustomersOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getCustomersFirstOfSaleObject,
                                    TypeOfCustomerRootCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "visits-by-collab":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbVisitsOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getVisitsOfSaleObject,
                                    HrRootOccupationRateCategory,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "products-ca":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getSalesCaOfSaleObject,
                                    Day.prototype.getSalesCaTotal,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    ProductStatCategorie.ALL,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "sales-by-visit":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbSubSalesOfSaleObject,
                                    Day.prototype.getNbSalesTotal,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.NO_AGREGATION,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "penetration-rate":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbFirstCustomersOfSaleObject,
                                    Day.prototype.getTotalFirstCustomers,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.NO_AGREGATION,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "fidelity-rate":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbSubVisitsOfSaleObject,
                                    Day.prototype.getNbFirstCustomersOfSaleObject,
                                    ReportTemporalAgregateFunctionType.DAILY_SUM,
                                    ReportTotalAgregateFunctionType.NO_AGREGATION,
                                    Day.prototype.getVisitsOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                            case "daily-average-nb-sales":
                                dataSource = new ReportDatasSource(
                                    idReportModel,
                                    Day.prototype.getNbSubSalesOfSaleObject,
                                    null,
                                    ReportTemporalAgregateFunctionType.DAILY_AVERAGE,
                                    ReportTotalAgregateFunctionType.SUM_CATEGORIES,
                                    Day.prototype.getSubSalesOfSaleObject,
                                    RootStatCategorie,
                                    currentCategorieLabel,
                                    currentCategoryType,
                                    taxMode,
                                    typeOfData);
                                break;
                        }
                        return dataSource;
                    }
                }

                return {
                    getInstance: function () {
                        if (!instance) {
                            instance = new constructeur();
                            instance.constructeur = null;

                        }
                        return instance;
                    }
                };
            })();

            return DataSourceFactory;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/views/statistics/report/DataSourceFactory.js